/**
 * DURMAH PRICING CONFIGURATION
 * 
 * This is the SINGLE SOURCE OF TRUTH for all pricing displayed in the UI.
 * Changing values here will update /pricing, /pricing-policy, and all 
 * relevant calculation badges.
 */

export const PRICING_CONFIG = {
    TRIAL: {
        days: 14,
        cardRequired: false,
        autoConverts: false,
    },
    MONTHLY: {
        price: 29.90,
        label_short: "/ mo",
        label_long: "/ month",
    },
    ANNUAL: {
        price: 229.00,
        label_short: "/ yr",
        label_long: "/ year",
        months: 12,
    },
    LNAT: {
        price: 39.00,
        duration: "3 months",
        type: "one-off",
    },
    CURRENCY: {
        symbol: "£",
        code: "GBP",
    }
};

// HELPER CALCULATIONS
export const ANNUAL_SAVINGS = (PRICING_CONFIG.MONTHLY.price * 12) - PRICING_CONFIG.ANNUAL.price;
export const MONTHLY_EQUIVALENT = PRICING_CONFIG.ANNUAL.price / 12;

export function formatGbp(amount: number): string {
    return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: PRICING_CONFIG.CURRENCY.code,
    }).format(amount);
}

export const MONTHLY_PRICE_LABEL = formatGbp(PRICING_CONFIG.MONTHLY.price);
export const ANNUAL_PRICE_LABEL = formatGbp(PRICING_CONFIG.ANNUAL.price);
export const LNAT_PRICE_LABEL = formatGbp(PRICING_CONFIG.LNAT.price);
export const ANNUAL_SAVINGS_LABEL = formatGbp(ANNUAL_SAVINGS);
export const MONTHLY_EQUIVALENT_LABEL = formatGbp(MONTHLY_EQUIVALENT);

export const PRICING_MESSAGES = {
    FULL_TERM_COVERAGE: "Join anytime. Stay covered through your academic journey — including your next academic year.",
    ANNUAL_MICRO_NOTE: "Annual pricing is shown for students who prefer one 12-month plan.",
    ANNUAL_BODY: "Full access to Durmah for 12 months — tutorials, exam preparation, assignment support, and your personal AI study companion. Built to support your current studies — and carry you confidently into your next academic year.",
    ANNUAL_CARD_SUPPORT: "£229 billed yearly. Renews annually until cancelled.",
    MONTHLY_BODY: "Everything included. Flexible month-to-month access for exam periods or ongoing support.",
    MONTHLY_CARD_SUPPORT: "Cancel anytime. No commitment.",
    LNAT_CARD_SUPPORT: "One-time payment. No subscription.",
    ANNUAL_SAVINGS_LABEL: `Save £${ANNUAL_SAVINGS.toFixed(2)} / Year`,
    ANNUAL_BADGE: `BEST VALUE • SAVE £${ANNUAL_SAVINGS.toFixed(2)}/YR`,
    MONTHLY_EQUIVALENT_LABEL: `Equivalent monthly cost: £${MONTHLY_EQUIVALENT.toFixed(2)}/month`
};
